module.exports = __webpack_public_path__ + "img/classify_3.941ca2b3.png";